import { render, staticRenderFns } from "./PgBillingHistory.vue?vue&type=template&id=0bdcf980&scoped=true&"
import script from "./PgBillingHistory.vue?vue&type=script&lang=js&"
export * from "./PgBillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./PgBillingHistory.vue?vue&type=style&index=0&id=0bdcf980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcf980",
  null
  
)

export default component.exports